import { config } from '../../config/config';
import { ChartSymbol } from '../../context/chart/chartTypes';

const verifyChartSymbol = (symbol: any): symbol is ChartSymbol =>
    config.chartSymbols.includes(symbol);

export default verifyChartSymbol;
